import type { InternalNetworkAttackPathEventDto } from '@terra/shared-contracts-internal-network';

const hasCredentialIdentity = (
  event: Extract<
    InternalNetworkAttackPathEventDto,
    { kind: 'CREDENTIAL_OBTAINED' }
  >,
): boolean =>
  Boolean(
    event.username?.trim() ||
      event.domain?.trim() ||
      event.credentialId?.trim(),
  );

export const dropAttackPathPlaceholderCredentials = (
  events: InternalNetworkAttackPathEventDto[],
): InternalNetworkAttackPathEventDto[] =>
  events.filter(
    (event) =>
      event.kind !== 'CREDENTIAL_OBTAINED' || hasCredentialIdentity(event),
  );
